import styled from 'styled-components';

export const Container = styled.div`
  .validator-recap-container-title {
    font-weight: bold;
    color: #0072c6;
    text-transform: uppercase;
    padding: 0px 5px 0px 0px;
  }
  .section {
    justify-content: flex-start;
    flex-direction: row;
    display: flex;
    align-items: center;
    line-height: 0px;
  }
  .item-validator {
    color: rgba(0, 0, 0, 0.87);
    margin: 0;
    font-size: 0.875rem;
    font-family: Roboto;
    font-weight: 400;
    line-height: 1.43;
    font-weight: bold;
  }
`;
